import { render, staticRenderFns } from "./LoginTitle.vue?vue&type=template&id=5bc563a1&scoped=true&"
import script from "./LoginTitle.vue?vue&type=script&lang=js&"
export * from "./LoginTitle.vue?vue&type=script&lang=js&"
import style0 from "./LoginTitle.vue?vue&type=style&index=0&id=5bc563a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc563a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
